var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _g3, _path13, _path14, _g4, _rect, _rect2, _rect3, _rect4, _rect5, _path15, _g5, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 213,
    viewBox: "0 0 244 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M132.245 182.178C177.422 182.178 214.139 145.462 214.139 100.285C214.139 55.1075 177.422 18.3906 132.245 18.3906C86.8993 18.3906 50.3516 54.9383 50.3516 100.285C50.3516 145.462 86.8993 182.178 132.245 182.178Z",
    fill: "#FFC691"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0401 163.383C74.1386 162.971 75.2946 162.423 76.1861 161.631C77.2448 160.689 77.6754 159.477 77.9645 158.2C78.3358 156.561 78.4841 154.814 78.9342 153.171C79.1009 152.561 79.4217 152.331 79.5593 152.229C79.9071 151.97 80.2588 151.901 80.5896 151.927C80.9816 151.957 81.5202 152.113 81.8744 152.805C81.9249 152.904 81.9905 153.054 82.0347 153.261C82.0669 153.413 82.0877 153.886 82.1218 154.082C82.2071 154.563 82.2784 155.044 82.3453 155.527C82.5682 157.137 82.6964 158.505 83.4003 159.984C84.3555 161.991 85.3126 163.22 86.6106 163.764C87.8657 164.29 89.3664 164.191 91.2837 163.779C91.4662 163.732 91.6467 163.692 91.8254 163.66C92.6707 163.504 93.4789 164.088 93.6449 164.975C93.8109 165.86 93.2737 166.723 92.4359 166.918C92.261 166.959 92.0887 166.997 91.9182 167.032C89.3272 167.707 86.3278 170.117 84.5847 172.226C84.0474 172.877 83.2608 174.695 82.4583 175.855C81.8662 176.711 81.2007 177.275 80.642 177.474C80.2676 177.609 79.952 177.588 79.6912 177.52C79.3124 177.422 78.998 177.206 78.7569 176.862C78.6255 176.674 78.5037 176.423 78.4456 176.101C78.4178 175.946 78.4147 175.553 78.4153 175.375C78.2518 174.783 78.0517 174.205 77.9058 173.607C77.558 172.182 76.8755 171.28 76.0648 170.088C75.3066 168.972 74.4922 168.272 73.2984 167.712C73.1431 167.672 71.8899 167.349 71.4473 167.164C70.8008 166.892 70.4927 166.437 70.381 166.192C70.1909 165.776 70.1714 165.413 70.2093 165.11C70.2655 164.662 70.4561 164.28 70.7945 163.971C71.0041 163.779 71.3173 163.592 71.7365 163.501C72.0603 163.43 72.9195 163.389 73.0401 163.383ZM80.392 161.06C80.4501 161.196 80.5119 161.333 80.5776 161.471C81.9766 164.412 83.5411 166.054 85.4426 166.85L85.5064 166.876C84.2343 167.87 83.0827 168.981 82.2026 170.046C81.8403 170.485 81.3605 171.396 80.8421 172.33C80.3712 170.719 79.6009 169.58 78.6325 168.155C77.8926 167.067 77.1173 166.248 76.1646 165.581C76.9039 165.182 77.6091 164.714 78.2234 164.168C79.2461 163.259 79.9223 162.205 80.392 161.06Z",
    fill: "#CCC6D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0833 105.513C63.0716 104.639 62.9597 103.758 62.7358 102.87C61.951 99.7561 58.4492 97.7569 54.7221 97.2868C50.9965 96.8168 47.1222 97.8865 45.629 100.595C44.7749 102.144 44.6571 103.479 45.0061 104.604C45.3536 105.724 46.1782 106.652 47.2974 107.375C50.4177 109.389 55.8825 109.8 58.3756 108.958C59.5286 108.568 60.6551 108.098 61.7521 107.56C61.1248 111.081 58.7878 114.416 55.6689 117.422C48.8907 123.954 38.3721 128.912 32.6438 130.735C32.3361 130.833 32.1652 131.168 32.261 131.483C32.3567 131.797 32.6836 131.974 32.9913 131.876C38.833 130.017 49.5563 124.953 56.4686 118.291C60.0396 114.85 62.5842 110.977 63.0186 106.905C71.0912 102.492 77.7207 94.4862 83.3886 87.7489C83.5992 87.5003 83.5713 87.1222 83.3268 86.9067C83.0824 86.6928 82.7142 86.7199 82.5036 86.97C77.0669 93.4316 70.7569 101.118 63.0833 105.513ZM61.9097 106.153C61.9539 105.171 61.8596 104.173 61.6049 103.167C60.926 100.472 57.8057 98.8778 54.5793 98.471C52.6016 98.2224 50.568 98.4273 48.9732 99.1565C47.9704 99.6145 47.1442 100.279 46.6465 101.183C45.9927 102.368 45.8513 103.382 46.1193 104.243C46.3873 105.109 47.053 105.805 47.9203 106.364C50.7639 108.2 55.7396 108.591 58.0089 107.824C59.3474 107.372 60.6463 106.808 61.9097 106.153Z",
    fill: "#E77710"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.506 79.8108C230.044 77.4419 230.213 73.5503 227.844 71.0122C225.475 68.4742 221.583 68.305 219.045 70.6738C216.507 73.0427 216.338 76.9343 218.707 79.4724C220.907 81.8412 224.968 82.1796 227.506 79.8108Z",
    fill: "#FFAE64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.844 51.8931C228.859 50.8778 229.028 49.1858 228.013 48.1706C226.998 47.1554 225.306 46.9862 224.291 48.0014C223.276 49.0166 223.106 50.7086 224.122 51.7239C225.137 52.9083 226.829 52.9083 227.844 51.8931Z",
    fill: "#FFAE64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.348 13.4838C162.025 12.807 162.194 11.6226 161.517 10.9458C160.84 10.269 159.656 10.0998 158.979 10.7766C158.302 11.4534 158.133 12.6378 158.81 13.3146C159.487 13.9914 160.671 14.1606 161.348 13.4838Z",
    fill: "#FFAE64"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_406_144904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2157 25.8066L92.3936 55.2822C93.3205 56.3945 93.3205 57.8775 92.2083 58.8044L63.4742 86.0555C62.3619 86.9824 60.8789 86.9824 59.952 85.8701L23.988 47.867C23.0611 46.7547 23.0611 45.2716 24.1734 44.3447L45.1215 24.6943L64.2157 25.8066Z",
    fill: "#FFC691"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9355 24.3232L52.7215 32.48C53.8338 33.5923 55.6876 33.5923 56.7999 32.48L64.0298 25.6209",
    fill: "#FFAE64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1602 49.7206C47.1602 49.1644 47.3455 48.6083 47.5309 48.0521C47.7163 47.496 47.9017 46.9398 48.0871 46.3837C48.2724 45.8276 48.6432 45.2714 49.014 44.7153C49.3847 44.1591 49.9409 43.603 50.497 43.0468C51.2385 42.3053 51.9801 41.7492 52.907 41.3784C53.6485 41.0076 54.5754 40.8223 55.3169 40.8223C56.0584 40.8223 56.9854 41.0076 57.7269 41.193C58.4684 41.5638 59.2099 42.1199 59.9514 42.6761C60.5076 43.2322 61.0637 43.9737 61.2491 44.7153C61.4345 45.2714 61.6199 46.0129 61.8053 46.7545C61.8053 47.3106 61.8053 48.0521 61.8053 48.6083C61.6199 49.1644 61.6199 49.7206 61.4345 50.2767C61.4345 50.8328 61.2491 51.2036 61.2491 51.7597C61.2491 52.1305 61.2491 52.5013 61.6199 52.872L63.1029 55.0966L60.8784 57.1358L58.6538 55.0966C58.283 54.7258 57.9123 54.3551 57.7269 53.7989C57.5415 53.2428 57.5415 52.872 57.5415 52.3159C57.5415 51.7597 57.7269 51.2036 57.7269 50.6475C57.9123 50.0913 57.9123 49.5352 57.9123 48.979C57.9123 48.4229 57.9123 47.8667 57.7269 47.3106C57.5415 46.7545 57.1707 46.1983 56.8 45.6422C56.6146 45.2714 56.2438 45.086 55.8731 44.9006C55.5023 44.7153 55.1315 44.7153 54.7608 44.7153C54.39 44.7153 54.0193 44.9006 53.6485 45.086C53.2777 45.2714 52.907 45.4568 52.5362 45.8276C52.1654 46.1983 51.7947 46.7545 51.4239 47.1252C51.2385 47.496 51.0532 47.8667 50.8678 48.4229C50.6824 48.7936 50.6824 49.1644 50.6824 49.3498C50.6824 49.5352 50.497 49.7206 50.3116 49.9059C50.1263 50.2767 49.5701 50.2767 49.1993 50.0913L47.1602 49.7206ZM64.2152 62.6972C64.0298 62.5118 63.8444 62.1411 63.6591 61.7703C63.4737 61.3996 63.4737 61.0288 63.4737 60.658C63.4737 59.9165 63.8444 59.175 64.4006 58.6188C64.586 58.4335 64.9567 58.2481 65.3275 58.0627C65.6983 57.8773 66.069 57.8773 66.4398 57.8773C67.5521 57.8773 68.6644 58.6188 69.0351 59.7311C69.2205 60.1019 69.2205 60.4727 69.2205 60.8434C69.2205 61.2142 69.0351 61.5849 69.0351 61.9557C68.8497 62.3265 68.6644 62.5118 68.2936 62.8826C68.1082 63.068 67.7374 63.4388 67.3667 63.4388C66.6252 63.6241 65.8836 63.6241 65.3275 63.4388C64.7714 63.2534 64.4006 63.068 64.2152 62.6972Z",
    fill: "#EBF9FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.629 15.9746L103.103 27.0289C102.732 28.5119 103.659 30.1803 105.142 30.5511L114.92 33.3139",
    fill: "#FFAE64"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.708 69.7414C109.264 69.556 109.821 69.3706 110.377 69.1852C110.933 68.9998 111.489 68.8145 112.231 68.8145C112.972 68.8145 113.528 68.8145 114.27 68.8145C115.011 68.8145 115.753 68.9998 116.494 69.1852C117.421 69.3706 118.348 69.9267 119.09 70.4829C119.831 71.039 120.387 71.5952 120.943 72.3367C121.314 73.0782 121.685 73.8197 121.87 74.5613C122.056 75.4882 121.87 76.4151 121.685 77.1566C121.5 77.8981 121.129 78.6396 120.573 79.3812C120.202 79.9373 119.646 80.4935 119.09 80.8642C118.533 81.235 117.977 81.6057 117.421 81.7911L115.753 82.3473C115.382 82.5326 114.826 82.718 114.455 82.9034C114.084 83.0888 113.714 83.4596 113.714 83.8303L112.601 86.2403L109.635 84.9426L110.191 81.9765C110.191 81.4204 110.562 81.0496 110.933 80.6788C111.304 80.3081 111.674 79.9373 112.231 79.7519C112.787 79.5666 113.343 79.3812 113.714 79.1958C114.27 79.0104 114.826 78.825 115.382 78.4543C115.938 78.2689 116.309 77.8981 116.865 77.5274C117.236 77.1566 117.607 76.6005 117.792 75.8589C117.792 75.6736 117.792 75.3028 117.792 74.932C117.792 74.5613 117.607 74.1905 117.421 73.8197C117.236 73.449 116.865 73.2636 116.494 72.8928C116.124 72.7075 115.753 72.5221 115.197 72.3367C114.64 72.1513 114.084 72.1513 113.343 72.1513C112.972 72.1513 112.416 72.1513 112.045 72.3367C111.674 72.3367 111.304 72.5221 111.118 72.5221C110.933 72.5221 110.747 72.7075 110.377 72.5221C110.006 72.5221 109.635 72.1513 109.635 71.7806L108.708 69.7414ZM105.928 91.0602C106.113 90.6894 106.113 90.3187 106.484 90.1333C106.669 89.7625 107.04 89.5771 107.225 89.3918C107.967 89.021 108.708 89.021 109.264 89.2064C109.635 89.3917 110.006 89.5771 110.191 89.7625C110.377 89.9479 110.747 90.3187 110.933 90.504C111.674 91.8017 111.118 93.4701 109.821 94.0263C109.079 94.397 108.338 94.397 107.781 94.2117C107.411 94.0263 107.04 94.0263 106.854 93.6555C106.484 93.4701 106.298 93.0994 106.113 92.914C105.928 92.5432 105.928 92.3578 105.742 91.9871C105.928 91.8017 105.928 91.4309 105.928 91.0602Z",
    fill: "#EBF9FD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_406_144904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.135 106.862L189.149 134.667C188.21 135.483 186.502 135.539 185.64 134.421L159.502 104.963C158.686 104.024 158.63 102.316 159.748 101.455L198.856 65.9453C199.795 65.1298 201.503 65.0735 202.364 66.1919L221.255 87.5591L219.135 106.862Z",
    fill: "#FFC691"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.168 87.9644L212.765 95.4838C211.693 96.525 211.615 98.4589 212.477 99.5772L219.001 107.088",
    fill: "#FFAE64"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M195.909 89.4807C196.494 89.5218 196.945 89.7886 197.53 89.8297C198.115 89.8708 198.566 90.1376 199.243 90.5378C199.921 90.938 200.372 91.2048 200.87 91.6511C201.547 92.0513 202.044 92.4976 202.588 93.1235C203.311 93.7032 203.767 94.7343 203.952 95.4525C204.362 96.3041 204.367 97.0684 204.598 97.9661C204.603 98.7305 204.429 99.541 204.254 100.351C203.9 101.208 203.32 101.931 202.695 102.475C202.248 102.973 201.397 103.383 200.725 103.747C200.232 104.065 199.334 104.296 198.75 104.255C198.165 104.214 197.447 104.398 196.816 104.177L195.195 103.828C194.79 103.741 194.205 103.7 193.8 103.613C193.394 103.526 192.856 103.664 192.768 104.069L190.665 105.567L188.716 103.197L190.635 100.981C190.902 100.53 191.44 100.391 191.979 100.253C192.517 100.114 192.877 100.022 193.461 100.063C194.046 100.104 194.498 100.371 194.903 100.458C195.488 100.499 195.939 100.766 196.703 100.761C197.288 100.802 197.647 100.71 198.411 100.705C198.95 100.566 199.443 100.248 200.068 99.7047C200.515 99.2071 201.095 98.4839 200.864 97.5862C200.951 97.1809 200.679 96.868 200.541 96.3294C200.269 96.0164 200.177 95.6573 199.679 95.211C199.361 94.7185 198.91 94.4517 198.412 94.0054C198.186 93.872 197.735 93.6052 197.33 93.518C197.104 93.3846 196.699 93.2973 196.473 93.1639C196.247 93.0305 196.068 93.0767 195.796 92.7637C195.57 92.6303 195.432 92.0917 195.565 91.866L195.909 89.4807ZM182.396 106.161C182.709 105.889 182.842 105.664 183.427 105.705C183.74 105.433 184.145 105.52 184.325 105.474C185.089 105.469 185.766 105.869 186.084 106.362C186.356 106.675 186.448 107.034 186.541 107.393C186.587 107.572 186.725 108.111 186.771 108.291C186.73 108.875 186.376 109.732 185.884 110.05C185.571 110.322 185.212 110.414 184.853 110.506C184.673 110.553 184.134 110.691 183.955 110.737C183.191 110.742 182.514 110.342 182.196 109.849C181.924 109.537 181.831 109.177 181.739 108.818C181.467 108.505 181.554 108.1 181.508 107.921C181.596 107.515 181.729 107.29 181.637 106.931C181.77 106.705 182.309 106.566 182.396 106.161Z",
    fill: "#EBF9FD"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_406_144904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.846 43.5178L164.591 83.5695C164.3 84.7787 162.942 85.8168 161.591 85.407L123.204 76.6133C121.994 76.3229 120.956 74.9651 121.366 73.6141L132.571 21.9929C132.861 20.7838 134.219 19.7457 135.57 20.1554L163.359 26.574L172.846 43.5178Z",
    fill: "#FFC691"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163.523 26.9555L161.051 37.9575C160.783 39.4279 161.844 41.0468 163.195 41.4566L172.868 43.78",
    fill: "#FFAE64"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.844 42.863C144.344 42.5567 144.866 42.5116 145.366 42.2054C145.866 41.8991 146.388 41.8541 147.172 41.7865C147.956 41.7189 148.478 41.6739 149.142 41.7481C149.926 41.6806 150.59 41.7548 151.396 41.9485C152.322 42.0002 153.292 42.5744 153.86 43.0517C154.688 43.5065 155.136 44.1257 155.846 44.7224C156.294 45.3416 156.623 46.1027 156.951 46.8638C157.161 47.7667 157.109 48.6921 156.916 49.4983C156.841 50.1625 156.386 50.9912 156.051 51.678C155.835 52.2229 155.238 52.9322 154.738 53.2385C154.238 53.5447 153.761 54.1122 153.119 54.2991L151.597 54.9566C151.217 55.121 150.717 55.4273 150.336 55.5917C149.956 55.7561 149.598 56.1816 149.762 56.5622L148.92 59.0031L145.957 58.2061L146.231 55.2878C146.186 54.7655 146.544 54.3399 146.902 53.9143C147.26 53.4887 147.499 53.205 147.999 52.8987C148.499 52.5924 149.021 52.5474 149.402 52.383C149.902 52.0768 150.424 52.0317 151.043 51.5836C151.543 51.2773 151.782 50.9936 152.401 50.5455C152.759 50.1199 152.975 49.575 153.169 48.7689C153.243 48.1046 153.295 47.1791 152.585 46.5825C152.421 46.2019 152.018 46.1051 151.592 45.7471C151.189 45.6503 150.906 45.4116 150.241 45.3373C149.696 45.1212 149.174 45.1662 148.51 45.092C148.248 45.1145 147.726 45.1596 147.346 45.3239C147.084 45.3465 146.704 45.5109 146.443 45.5334C146.181 45.5559 146.062 45.6978 145.659 45.601C145.398 45.6235 144.972 45.2655 144.95 45.0043L143.844 42.863ZM142.534 64.2904C142.631 63.8873 142.609 63.6261 143.109 63.3199C143.205 62.9168 143.586 62.7524 143.705 62.6105C144.324 62.1624 145.108 62.0948 145.653 62.311C146.056 62.4078 146.34 62.6465 146.623 62.8851C146.765 63.0045 147.191 63.3625 147.333 63.4818C147.639 63.9817 147.848 64.8846 147.632 65.4295C147.535 65.8326 147.297 66.1163 147.058 66.4001C146.939 66.5419 146.581 66.9675 146.461 67.1094C145.842 67.5575 145.059 67.6251 144.514 67.4089C144.111 67.3121 143.827 67.0734 143.543 66.8348C143.14 66.738 142.976 66.3574 142.834 66.2381C142.67 65.8576 142.647 65.5964 142.363 65.3577C142.341 65.0965 142.699 64.6709 142.534 64.2904Z",
    fill: "#EBF9FD"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_406_144904)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.7891,
    y: 61.1152,
    width: 80.4223,
    height: 100.113,
    rx: 5.12956,
    fill: "url(#paint0_linear_406_144904)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.893,
    y: 75.6543,
    width: 51.2956,
    height: 5.12956,
    rx: 2.56478,
    fill: "#E77710"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.32,
    x: 100.893,
    y: 93.0947,
    width: 64.577,
    height: 5.12956,
    rx: 2.56478,
    fill: "#FF7F38"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.32,
    x: 100.893,
    y: 110.535,
    width: 64.577,
    height: 5.12956,
    rx: 2.56478,
    fill: "#FF7F38"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.32,
    x: 100.893,
    y: 127.976,
    width: 64.577,
    height: 5.12956,
    rx: 2.56478,
    fill: "#FF7F38"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.32,
    x: 100.893,
    y: 145.416,
    width: 64.577,
    height: 5.12956,
    rx: 2.56478,
    fill: "#FF7F38"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.952 169.795C166.759 169.795 172.156 168.038 176.64 165.028L194.99 182.544L201.644 174.823L183.937 157.92C187.207 153.318 189.13 147.692 189.13 141.617C189.13 126.054 176.514 113.438 160.952 113.438C145.389 113.438 132.773 126.054 132.773 141.617C132.773 157.179 145.389 169.795 160.952 169.795ZM184.986 141.616C184.986 154.792 174.306 165.472 161.13 165.472C147.955 165.472 137.274 154.792 137.274 141.616C137.274 128.441 147.955 117.76 161.13 117.76C174.306 117.76 184.986 128.441 184.986 141.616Z",
    fill: "#CCC6D9"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_406_144904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.126 165.932C174.697 165.932 185.698 155.032 185.698 141.586C185.698 128.14 174.697 117.24 161.126 117.24C147.556 117.24 136.555 128.14 136.555 141.586C136.555 155.032 147.556 165.932 161.126 165.932Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.988 182.543L201.643 174.822L202.645 175.779C203.618 176.707 204.2 178.004 204.264 179.384C204.328 180.764 203.868 182.115 202.986 183.138C202.104 184.162 200.872 184.774 199.56 184.842C198.249 184.909 196.966 184.425 195.993 183.497L194.991 182.54L194.988 182.543Z",
    fill: "#E1DCEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_406_144904",
    x: 0.744373,
    y: 13.4093,
    width: 114.892,
    height: 107.175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.285
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.285
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_406_144904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_406_144904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_406_144904",
    x: 136.328,
    y: 54.0568,
    width: 107.498,
    height: 115.069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.285
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.285
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_406_144904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_406_144904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_406_144904",
    x: 98.7053,
    y: 8.77941,
    width: 96.7105,
    height: 110.574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.285
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.285
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_406_144904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_406_144904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_406_144904",
    x: 63.0117,
    y: 50.8561,
    width: 141.977,
    height: 161.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20.5183
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.3887
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_406_144904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_406_144904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_406_144904",
    x: 128.347,
    y: 109.033,
    width: 65.5572,
    height: 65.107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.10365
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_406_144904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_406_144904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_144904",
    x1: 134,
    y1: 61.1152,
    x2: 134,
    y2: 161.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.433e831f47e0fc4db0b1db784e822f19.svg";
export { ForwardRef as ReactComponent };